import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RequestListComponent } from './request-list/request-list.component';
import { RequestListFilterComponent } from './request-list/request-list-filter/request-list-filter.component';
import { RequestsRoutingModule } from './requests-routing.module';
import { CardViewComponent } from './request-list/card-view/card-view.component';
import { ContractModificationsCardViewComponent } from './contract-modifications/contract-modification-list/card-view/card-view.component';
import { RequestWizardComponent } from './request-wizard/request-wizard.component';
import { DirectiveModule } from 'src/app/extensions/directives/directive.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AddDelegateComponent } from './request-wizard/add-delegate/add-delegate.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { RequestEntryComponent } from './request-entry/request-entry.component';
import { RequestDetailComponent } from './request-detail/request-detail.component';
import { ContractModificationListComponent } from './contract-modifications/contract-modification-list/contract-modification-list.component';
import { ContractModificationWizardComponent } from './contract-modifications/contract-modification-wizard/contract-modification-wizard.component';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ClientDataListComponent } from './client-data/client-data-list/client-data-list.component';
import { AddClientDataRequestComponent } from './client-data/add-client-data-request/add-client-data-request.component';
import { ClientDataCardViewComponent } from './client-data/client-data-list/card-view/card-view.component';
import { AddContactInformationRequestComponent } from './client-data/add-client-data-request/add-contact-information-request/add-contact-information.component';
import { AddPersonalInformationRequestComponent } from './client-data/add-client-data-request/add-personal-information-request/add-personal-information-request.component';
import { AddAddressInformationRequestComponent } from './client-data/add-client-data-request/add-address-request/add-address-request.component';
import { AddAssociatesInformationRequestComponent } from './client-data/add-client-data-request/add-associates-request/add-associates-request.component';
import { AddOwnerInformationRequestComponent } from './client-data/add-client-data-request/add-beneficial-owner-request/add-beneficial-owner-request.component';
import { AddLegalInformationRequestComponent } from './client-data/add-client-data-request/add-legal-information-request/add-legal-information-request.component';
import { ClientDataRequestDetailsComponent } from './client-data/client-data-details/client-data-details.component';
import { ContractModificationDetailComponent } from './contract-modifications/contract-modification-detail/contract-modification-detail.component';
import { PaymentSourceComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/payment-source/payment-source.component';
import { PaymentAmountComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/payment-amount/payment-amount.component';
import { RequestPurposeComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/request-purpose/request-purpose.component';
import { PostponePeriodComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/postpone-period/postpone-period.component';
import { RequestPreviewComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/request-preview/request-preview.component';
import { RequestSentComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/request-sent/request-sent.component';
import { ModificationTypeComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/modification-type/modification-type.component';
import { RequestReasonComponent } from './contract-modifications/contract-modification-wizard/wizard-steps/request-reason/request-reason.component';
import { UploaderComponent } from './contract-modifications/contract-modification-wizard/uploader/uploader.component';
import { ClientRequestSentComponent } from './client-data/add-client-data-request/request-sent/client-request-sent.component';
import { ClientDataUploaderComponent } from './client-data/add-client-data-request/uploader/uploader.component';
import { FilesHandler } from './client-data/utils/files-handler';
import { RequestDetailCategorySelectorComponent } from './shared-components/request-detail-category-selector/request-detail-category-selector.component';
import { RequestCommentComponent } from './shared-components/request-comment/request-comment.component';
import { RequestDocumentsComponent } from './shared-components/request-documents/request-documents.component';
import { AssetDocumentUploaderComponent } from './request-wizard/uploader/uploader.component';
import { ClientDataRequestPreviewComponent } from './client-data/add-client-data-request/client-data-request-preview/client-data-request-preview.component';
import { RequestRightsGuard } from './request-right.guard';
import { IconsModule } from '@progress/kendo-angular-icons';

@NgModule({
  imports: [
    CommonModule,
    RequestsRoutingModule,
    InputsModule,
    DropDownsModule,
    FormsModule,
    PipeModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule.forChild(),
    DirectiveModule,
    DateInputsModule,
    ComponentsModule,
    IconsModule,
  ],
  declarations: [
    RequestListComponent,
    RequestListFilterComponent,
    CardViewComponent,
    ContractModificationsCardViewComponent,
    RequestWizardComponent,
    AssetDocumentUploaderComponent,
    AddDelegateComponent,
    RequestEntryComponent,
    RequestDetailComponent,
    ClientDataListComponent,
    AddClientDataRequestComponent,
    AddPersonalInformationRequestComponent,
    AddContactInformationRequestComponent,
    AddAddressInformationRequestComponent,
    AddAssociatesInformationRequestComponent,
    AddOwnerInformationRequestComponent,
    AddLegalInformationRequestComponent,
    ClientDataCardViewComponent,
    ClientDataRequestDetailsComponent,
    ContractModificationListComponent,
    ContractModificationWizardComponent,
    ContractModificationDetailComponent,
    PaymentSourceComponent,
    PaymentAmountComponent,
    RequestPurposeComponent,
    PostponePeriodComponent,
    RequestPreviewComponent,
    RequestSentComponent,
    ModificationTypeComponent,
    RequestReasonComponent,
    UploaderComponent,
    ClientRequestSentComponent,
    ClientDataUploaderComponent,
    RequestDetailCategorySelectorComponent,
    RequestCommentComponent,
    RequestDocumentsComponent,
    ClientDataRequestPreviewComponent,
  ],
  exports: [AddDelegateComponent],
  providers: [FilesHandler, RequestRightsGuard],
})
export class RequestsModule {}
